<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'WhoIsAvailable',
};
</script>

<style scoped>

</style>
